<template>
  <div class="current-subscription-wrapper">
    <h2 class="current-subscription-title">
      {{ $t('pages.billing.currentSubscription') }}
    </h2>

    <ib-card class="current-subscription-card" :animation="false">
      <div class="d-flex justify-space-between">
        <div v-if="subscriptionIsFreeTrial">
          <p class="m-0 mb-1 subscription-plan-name font-outfit-medium">
            {{ $t('pages.billing.freePlan') }}
          </p>

          <p v-if="!subscriptionIsFreeTrialExpired" class="m-0">
            {{ $t('pages.billing.yourFreeTrialExpiresOn') }} <span class="uppercase font-outfit-bold">{{ $moment(getCurrentUser.freeTrial).format('DD MMM YYYY') }}</span>
          </p>
          <p v-else class="m-0">
            {{ $t('pages.billing.yourFreeTrialExpiredOn') }} <span class="uppercase font-outfit-bold">{{ $moment(getCurrentUser.freeTrial).format('DD MMM YYYY') }}</span>
          </p>
        </div>

        <div v-if="!subscriptionIsFreeTrial && isSubscribed" class="subscription-info-wrapper">
          <p class="m-0 subscription-plan-name font-outfit-medium">
            {{ fullSubscriptionPlanName }}
          </p>

          <p v-if="getLastPayment" class="m-0 price-per-month mb-2">
            <span class="font-outfit-bold">{{ getLastPayment.currency }} {{ getLastPayment.sale_gross }}</span> {{ paymentTypeText }}
          </p>

          <div v-if="!isCurrentSubscriptionDeleted" class="next-bill-date-wrapper">
            <p class="m-0">
              {{ $t('pages.billing.yourSubscriptionRenewsOn') }} <span class="uppercase font-outfit-bold">{{ nextBillDate }}</span>
            </p>

            <p v-if="getLastPayment" class="m-0">
              {{ $t('pages.billing.youNextPaymentWillBe') }} <span class="uppercase font-outfit-bold">{{ isSubscriptionLifetime ? '-' : `${getLastPayment.currency} ${getLastPayment.sale_gross}` }}</span>
            </p>
          </div>
          <p v-else-if="!isSubscriptionLifetime" class="m-0 text-red-light">
            {{ $t('pages.billing.yourSubscriptionHasBeenCanceledAndExpiresOn') }}
            <span class="uppercase font-outfit-bold">{{ getCurrentUser.subscription.cancel_date ? $moment(getCurrentUser.subscription.cancel_date).format('MMMM DD,YYYY') : $moment(currentUserSubscription.nextBillDate.date).format('MMMM DD,YYYY') }}</span>
          </p>
        </div>

        <div v-else-if="!subscriptionIsFreeTrial && !isSubscribed" class="subscription-info-wrapper">
          <p class="m-0 subscription-plan-name font-outfit-medium">
            {{ $t('pages.billing.none') }}
          </p>

          <p class="m-0">
            {{ $t('pages.billing.yourSubscriptionHasExpiredOn') }} <span class="uppercase font-outfit-bold">{{ $moment(getCurrentUser.subscription.cancel_date).format('MMMM DD,YYYY') }}</span>
          </p>
        </div>

        <current-subscription-buttons class="d-none d-sm-flex" />
      </div>

      <div v-if="isDisabled" class="cancel-wrapper">
        <!-- Cancel Account-->
        <p class="account-canceled">
          {{ $t('pages.myProfile.accountCanceledMessage') }}
        </p>
        <!-- /Cancel Account-->
      </div>
    </ib-card>
    <current-subscription-buttons class="mt-4 d-sm-none" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import paymentTypes from '@/data/paymentTypes.json'

import CurrentSubscriptionButtons from '@/views/Billing/Components/CurrentSubscriptionButtons.vue'
import UserSubscriptionMixin from '@/mixins/permissions/userSubscription'

export default {
  name: 'CurrentSubscription',

  components: {
    CurrentSubscriptionButtons
  },

  mixins: [UserSubscriptionMixin],

  data () {
    return {
      paymentNextBillDate: '',
      paymentTypes,
      dialogChangeBillingVisible: false
    }
  },

  computed: {
    ...mapGetters('user', ['subscriptionPlanName', 'getCurrentUser', 'getCurrentUser', 'isDisabled', 'isSubscribed']),
    ...mapGetters('user/paymentHistory', ['getLastPayment']),

    fullSubscriptionPlanName () {
      return `${this.subscriptionPlanName} - ${this.paymentType} - ${this.numberOfIdeasText}`
    },

    currentUserSubscription () {
      return this.getCurrentUser.subscription
    },

    paymentType () {
      return this.paymentTypes[this.currentUserSubscription.type]
    },

    numberOfIdeasText () {
      return `${this.currentUserSubscription.ideas} ${Number(this.currentUserSubscription.ideas) > 1 ? 'ideas' : 'idea'}`
    },

    nextBillDate () {
      if (!this.getCurrentUser.subscription.nextBillDate) return '/'

      const options = { year: 'numeric', month: 'long', day: 'numeric' }
      const today = new Date(this.$store.state.user.subscription.nextBillDate.date)

      return today.toLocaleDateString('en-US', options)
    },

    isSubscriptionLifetime () {
      return this.currentUserSubscription.type === 'lifetime'
    },

    paymentTypeText () {
      if (this.isSubscriptionLifetime) return this.$t('pages.billing.perLifetime')

      return this.currentUserSubscription.type === 'year' ? this.$t('pages.billing.perYear') : this.$t('pages.billing.perMonth')
    }
  },

  mounted () {
    this.fetchUserData()
  },

  methods: {
    ...mapActions('user', {
      fetchUserData: 'getCurrentUser'
    })
  }
}
</script>

<style scoped lang="scss">
.current-subscription-wrapper {
  .current-subscription-title {
    font-size: 24px;
  }

  .current-subscription-card {
    padding: 30px 34px 30px 29px;
    min-height: 165px;

    .subscription-plan-name {
      font-size: 20px;
      color: $color-primary;
    }

    .price-per-month {
      font-size: 20px;
    }

    .payment-method-wrapper {
      column-gap: 10px;
      row-gap: 10px;
    }
  }
}
</style>
